import React from 'react'
import styles from './styles.module.css'

const index = () => {

  return (
    <div className={styles.notFoundContainer}>
        <h1>SORRY, PAGE NOT FOUND</h1>
        <p>The page you requested for could not be found</p>
        <img src="/assets/404/error-404.svg" alt="404" />
    </div>
  )
}

export default index